import { IWidget } from '@pages/monitoring/types';
import { WidgetResource } from '@pages/monitoring/types/widget';

export enum DashboardScope {
    Entity = 'entity',
    Global = 'global',
}

export interface IDashboardDefinition {
    name: string;
    widgets: IWidget[];
}

export interface IDashboardOptions {
    resource: WidgetResource;
    scope: DashboardScope;
}
